import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProfilePhotosService } from '../../service/profilePhotos.service';
import { User, UserLight } from '../../model/user.model';
import { SharedAppState } from '../../store/app.states';
import { Store } from '@ngrx/store';
import * as userActions from '../../store/actions/user.actions';

@Component({
    selector: 'lib-menu-profil-fuse',
    templateUrl: './menu-profil-fuse.component.html',
    styleUrls: ['./menu-profil-fuse.component.scss'],
})
export class MenuProfilFuseComponent {
    @Input() user: User | UserLight;

    constructor(
        private profilePhotosService: ProfilePhotosService,
        private store: Store<SharedAppState>,
    ) {

    }

    /**
     * methode pour charger un avatar.
     */
    uploadAvatar($event) {
        // on upload l'avatar sur le user.
        for (const file of $event.target.files) {
            const ext = file.name.substr(file.name.lastIndexOf('.') + 1)
            if (this.profilePhotosService.authorizedExtension.indexOf(ext.toLowerCase()) !== -1) {
                this.sendFile(file);
            }
        }
    }

    sendFile(file) {
        this.profilePhotosService.postProfilePhoto(this.user, file, 'validated').subscribe(photoProfile => {
            this.store.dispatch(userActions.GetUser());
        })
    }
}
